import React, {Fragment} from "react";
import {getWeeks, weekColSpan} from "./analyticsUtils";

export default function ({reportAnalytics, phase, enablePtoAnalytics}) {
  return (
    <tr>
      <th></th>
      {
        getWeeks(reportAnalytics.weeks[phase.guid], phase, reportAnalytics, enablePtoAnalytics).map(week => (
          <th data-align="center" key={phase.guid + week.numInPhase} colSpan={weekColSpan(reportAnalytics, phase, week, enablePtoAnalytics)}>{week.header}</th>
        ))
      }
      {!enablePtoAnalytics && (
        <Fragment>
          <th data-align="center">#</th>
          <th data-align="center">#</th>
        </Fragment>
      )}
    </tr>
  )
}
